import React, { useState } from 'react';
import { Modal, Button, Typography, Alert } from 'antd';
import { createCallMe } from '../utils/apiService';
import { setCallMeId } from '../utils/cookieUtils';

const { Text } = Typography;

/**
 * Call Me confirmation modal
 *
 * Props:
 * - visible: boolean
 * - onCancel: () => void
 * - onSubmitted: (callMeId: string) => void
 */
const CallMeConfirmModal = ({ visible, onCancel, onSubmitted }) => {
  const [submitting, setSubmitting] = useState(false);

  const isUat = window.location.hostname.includes('uat') || window.location.hostname.includes('localhost');

  const handleConfirm = async () => {
    if (isUat) {
      onSubmitted?.('UAT');
      return;
    }
    try {
      setSubmitting(true);
      const res = await createCallMe();
      const id = res?.callmeId || res?.id; // fallback in case API returns id
      if (!id) {
        throw new Error('No Call Me ID returned');
      }
      setCallMeId(id);
      onSubmitted?.(id);
    } catch (err) {
      console.error('CreateCallMe failed', err);
      // Bubble error to parent via onSubmitted not being called
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Confirm Call Me"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>,
        <Button key="confirm" type="primary" loading={submitting} onClick={handleConfirm}>
          Confirm
        </Button>,
      ]}
      maskClosable={false}
    >
      {isUat ? (
        <Alert
          style={{ marginBottom: '16px' }}
          message="Call me unavailable in UAT"
          description={
            <Text>
              Please note that Call Me functionality is not available in the UAT environment. Confirming this popup will not submit a call request.
            </Text>
          }
          type="error"
          showIcon
        />
      ) : (
        <Alert
          message="This will submit a 'Call Me' request."
          description={
            <Text>
              We'll call you as soon as the next agent is available. You can
              continue using the app while you wait.
            </Text>
          }
          type="info"
          showIcon
        />
      )}
    </Modal>
  );
};

export default CallMeConfirmModal;
